export const name = 'UnknownNetworkErrorException';

export default class UnknownNetworkErrorException extends Error {
  constructor(message) {
    super(message); // (1)
    this.name = name;
  }
}
